// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"141":"75b55e55","272":"96ba14f1","295":"23b31840","408":"4f5c7790","766":"fa8aa03d","806":"75b55e55"}[chunkId] + ".css";
};